module.exports = __webpack_public_path__ + "static/media/logo.fff20201.svg";